import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import EditarUtilizadorLayer from "../components/EditarUtilizadorLayer";
import { useTranslation } from "../i18n/I18nContext";

const EditarUtilizadorPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("utilizador.breadcrumb.edit")} />
      <EditarUtilizadorLayer />
    </MasterLayout>
  );
};

export default EditarUtilizadorPage;
